import React from "react";
import { Link } from "react-router-dom";
function Sidebar() {
  return (
    <>
      <nav className="sidebar sidebar-offcanvas sidebar-icon-only" id="sidebar">
        <ul className="nav">
          <li className="nav-item active hover-open">
            <Link className="nav-link" to="/dashboard">
              <i className="ti-home menu-icon">
                <i className="fa-solid fa-house" />
              </i>
              <span className="menu-title">Dashboard</span>
            </Link>
          </li>
          {/* <li className="nav-item">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#user1"
              aria-expanded="false"
              aria-controls="form-elements">
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-user" />
              </i>
              <span className="menu-title">User</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="user1">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/customerdetails">
                    Customer
                  </Link>
                </li>
                
                <li className="nav-item">
                  <Link className="nav-link" to="/professionalist">
                    Professionals
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/servicecategory">
                    Service Category
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}


          <li className="nav-item hover-open">
            <a
              className="nav-link"
           
              href="/userlist"
             
              title="Userlist"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa fa-users" aria-hidden="true"></i>
              </i>
              <span className="menu-title">User List</span>
             
            </a>
           
          </li>

          <li className="nav-item hover-open">
            <a
              className="nav-link"
           
              href="/contactrequest"
             
              title="Contactrequest"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa-solid fa-address-book" aria-hidden="true"></i>
              </i>
              <span className="menu-title">Contact Request</span>
             
            </a>
           
          </li>

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#user-elements"
              aria-expanded="false"
              aria-controls="form-elements"
              title="User"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa fa-users" aria-hidden="true"></i>
              </i>
              <span className="menu-title">User</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="user-elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/useradd">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/customerdetails">
                    List
                  </Link>
                </li>
              
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#professional-elements"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Professional"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa fa-user-tie"></i>
              </i>
              <span className="menu-title">Professional</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="professional-elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/professionaladd">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/professionalist">
                    List
                  </Link>
                </li>
               
              </ul>
            </div>
          </li>

           <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#suspend-elements"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Suspended list"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa-solid fa-user-lock"></i>
              </i>
              <span className="menu-title">Suspended</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="suspend-elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/user-suspend">
                    User
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/professional-suspend">
                    Prof
                  </Link>
                </li>
               
              </ul>
            </div>
          </li>
          {/* <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#Service-elements"
              aria-expanded="false"
              aria-controls="form-elements"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-server" />
              </i>
              <span className="menu-title">Service Category</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="Service-elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/add">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/servicelist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#subcat"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Service Category"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa-solid fa-timeline"></i>
              </i>
              <span className="menu-title">Service Category</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="subcat">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addsubcategory">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/subcategorylist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#propertytype"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Property type"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa-solid fa-building"></i>
              </i>
              <span className="menu-title">Property Type</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="propertytype">
              <ul className="nav flex-column sub-menu">
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/adds-property-type">
                    Add
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/property-type-list">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#property"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Property type"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa-solid fa-school"></i>
              </i>
              <span className="menu-title">Property </span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="property">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/add-property">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/property-list">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#aminity"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Property type"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa-brands fa-algolia"></i>
              </i>
              <span className="menu-title">Aminity</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="aminity">
              <ul className="nav flex-column sub-menu">
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/adds-property-type">
                    Add
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/aminities">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#banner_elements"
              aria-expanded="false"
              aria-controls="form-elements"        
              title="Banners"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-image" />
              </i>
              <span className="menu-title">Banner</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="banner_elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addbanner">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/bannerlist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#Blog"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Blog"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-brands fa-blogger-b" />
              </i>
              <span className="menu-title">Blog</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="Blog">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addblog">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/bloglist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          {/* <li className="nav-item hover-open ">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#portfolioz"
              aria-expanded="false"
              aria-controls="form-elements"
              title="News"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-newspaper" />
              </i>
              <span className="menu-title">News</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>

            <div className="collapse" id="portfolioz">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addnews">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/newslist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#projectsz"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Projects"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fas fa-project-diagram"></i>
              </i>
              <span className="menu-title">Projects</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="projectsz">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addproject">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/projectlist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#testimonial"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Testimonials"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa fa-quote-left" aria-hidden="true"></i>
              </i>
              <span className="menu-title">Testimonials</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="testimonial">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addtestimonail">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/testimoniallist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          {/* <li className="nav-item ">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#projects"
              aria-expanded="false"
              aria-controls="form-elements"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-users" />
           
              </i>
              <span className="menu-title">Client</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="projects">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addclient">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/clientlist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#adsz"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Ads"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-rectangle-ad" />
              </i>
              <span className="menu-title">Ads</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="adsz">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/ads">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/adslist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#subscribersz"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Subscribers"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-thumbs-up" />
              </i>
              <span className="menu-title">Subscribers</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="subscribersz">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/subscribers">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#contact"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Contacts"
            >
              <i className="ti-clipboard menu-icon">
                <i class="fa-solid fa-phone"></i>
              </i>
              <span className="menu-title">Contact Forms</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="contact">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/contactlist">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#enquiryz"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Enquiry"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa fa-info-circle" aria-hidden="true"></i>

              </i>
              <span className="menu-title">Enquiry</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="enquiryz">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addenquiry">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/enquiry">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#faq"
              aria-expanded="false"
              aria-controls="form-elements"
              title="Faq"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa fa-question" />
              </i>
              <span className="menu-title">Faq</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="faq">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/addfaq">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/faq">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>


          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#version"
              aria-expanded="false"
              aria-controls="form-elements"
              title="App version"
            >
              <i className="ti-clipboard menu-icon">
              <i class="fa fa-code-fork" aria-hidden="true"></i>
              </i>
              <span className="menu-title">App Version</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="version">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/versions-add">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/versions">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>


          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#Social"
              aria-expanded="false"
              aria-controls="form-elements"
              title="App version"
            >
            <i className="fa-brands fa-youtube menu-icon"></i>
             
              <span className="menu-title">Social Hub</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="Social">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/socialhub-add">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/socialhub">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          <li className="nav-item hover-open">
            <a
              className="nav-link"
              data-bs-toggle="collapse"
              href="#youtube"
              aria-expanded="false"
              aria-controls="form-elements"
              title="App version"
            >
            <i className="fa-brands fa-youtube menu-icon"></i>
             
              <span className="menu-title">Youtube Videos</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </a>
            <div className="collapse" id="youtube">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/video-add">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/videos">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          {/* <li className="nav-item ">
            <Link className="nav-link" to="/dashboard">
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-star" />
              </i>
              <span className="menu-title">Favorite List</span>
            </Link>
          </li> */}
          {/* <li className="nav-item">
            <Link
              className="nav-link"
              data-bs-toggle="collapse"
              to="#faq-elements"
              aria-expanded="false"
              aria-controls="form-elements"
            >
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-circle-question" />
              </i>
              <span className="menu-title">FAQ</span>
              <i className="menu-arrow">
                <i className="fa-solid fa-chevron-down" />
              </i>
            </Link>
            <div className="collapse" id="faq-elements">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="faqadd.html">
                    Add
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="faqlist.html">
                    List
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}
          {/* <li className="nav-item ">
            <Link className="nav-link" to="reports.html">
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-circle-exclamation" />
              </i>
              <span className="menu-title">Reports</span>
            </Link>
          </li>
          <li className="nav-item ">
            <Link className="nav-link" to="help.html">
              <i className="ti-clipboard menu-icon">
                <i className="fa-solid fa-handshake-angle" />
              </i>
              <span className="menu-title">Help Request</span>
            </Link>
          </li> */}
        </ul>
      </nav>
    </>
  );
}

export default Sidebar;
